export default __webpack_public_path__ + "static/media/mirtilo.883d23c9.png";